import { useRef, useState } from "react";
import api from "../api/client";
import { Upload, Loader2 } from "lucide-react";

/**
 * Tiny file upload helper.
 * Calls /api/upload and returns { id, original_filename, size, content_type }.
 */
export default function FileUploader({ onUploaded, accept = ".pdf,application/pdf,image/*", label = "Upload file", testid = "file-uploader" }) {
  const inputRef = useRef(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const handle = async (e) => {
    const f = e.target.files?.[0];
    if (!f) return;
    setBusy(true); setError("");
    try {
      const fd = new FormData();
      fd.append("file", f);
      const { data } = await api.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      onUploaded?.(data);
    } catch (err) {
      setError(err.response?.data?.detail?.toString?.() || err.message);
    } finally {
      setBusy(false);
      if (inputRef.current) inputRef.current.value = "";
    }
  };

  return (
    <div className="flex items-center gap-2 flex-wrap" data-testid={testid}>
      <input ref={inputRef} type="file" accept={accept} className="hidden" onChange={handle} data-testid={`${testid}-input`} />
      <button type="button" onClick={() => inputRef.current?.click()} disabled={busy} className="btn-ghost !py-2 !px-3 !text-xs" data-testid={`${testid}-trigger`}>
        {busy ? <Loader2 size={12} className="animate-spin" /> : <Upload size={12} strokeWidth={1.6} />} {busy ? "Uploading…" : label}
      </button>
      {error && <span className="text-xs text-[color:var(--accent-2)]" data-testid={`${testid}-error`}>{error}</span>}
    </div>
  );
}

export function fileDownloadUrl(fileId) {
  const token = localStorage.getItem("youfit_token");
  const base = process.env.REACT_APP_BACKEND_URL;
  return `${base}/api/files/${fileId}?auth=${encodeURIComponent(token || "")}`;
}
